import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { LoadingScreenService } from '@shared/ui/loading-screen/loading-screen.service';

export const loadingScreenInitializerProvider: EnvironmentProviders = provideAppInitializer(() => {
  inject(LoadingScreenService);
});
